export default "__VITE_ASSET__DVzyY0tE__"